<section class="default-section">
  <article class="default-card">
    <div class="card page-jumbotron-card">
      <div class="page-jumbotron">
        <div class="page-jumbotron-image">
          <picture>
            <img
              [src]="imgPath + '/start/software-development.webp'"
              alt="Software-Entwicklung"
              class="jumbotron-image no-scale-crop top-rounded-image" />
          </picture>
        </div>

        <div class="page-jumbotron-content">
          <h1 class="jumbotron-headline">Software-Entwicklung</h1>
          <p class="jumbotron-lead">{{ LEAD_SOFTWARE_DEVELOPER }}</p>
          <a [queryParams]="{ categoryId: 'software-development' }" routerLink="/contact">
            <button color="primary" mat-flat-button>Kontaktieren Sie mich mit Ihrem Auftrag!</button>
          </a>
        </div>
      </div>
    </div>

    <h1 class="paragraph-headline">Projekterfahrungen</h1>

    <!-- DB Systel / iSAX -->
    <h2 class="paragraph-headline-2">DB Systel (Deutsche Bahn) / iSAX</h2>

    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>06/2026 – 09/2026</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Infrastruktur</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>Frankfurt am Main</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Test automation engineer (Java/Angular)</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Konzeption, Implementierung und Wartung automatisierter Softwaretests mit Playwright und Karate</li>
              <li>Entwicklung und Automatisierung von E2E-, Integrations- und Regressionstests</li>
              <li>Automatisierung von Frontend-Tests für Angular-Anwendungen mit Playwright</li>
              <li>Automatisierung von API- und Integrationstests mit Karate</li>
              <li>Analyse und Behebung fehlerhafter bzw. instabiler automatisierter Tests</li>
              <li>Integration automatisierter Tests in CI/CD-Pipelines</li>
              <li>Optimierung und Weiterentwicklung der Test- und CI/CD-Infrastruktur</li>
              <li>Durchführung von Code Reviews</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Angular 22</li>
              <li>Playwright 1.63</li>
              <li>TypeScript</li>
              <li>Java 21</li>
              <li>Karate Framework 1.4.1</li>
              <li>Amazon Kiro (coding agent)</li>
              <li>GitHub Copilot (coding agent)</li>
              <li>PostgreSQL Datenbank</li>
              <li>Git (GitLab)</li>
              <li>Jira</li>
              <li>Confluence</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- DVAG / Etengo -->
    <h2 class="paragraph-headline-2">DVAG / Etengo</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>03/2026 – 06/2026</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Finanzen</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>Frankfurt am Main</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Full-Stack-Entwickler (Kotlin/Angular)</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Planung und Entwicklung einer neuen Antragsübersicht im bestehenden Ökosystem</li>
              <li>Einsatz von agentischem Coding</li>
              <li>CI/CD mit GitHub Actions</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Kotlin (inkl. Spring, Spring Boot, JPA)</li>
              <li>Angular (TypeScript)</li>
              <li>Microsoft Azure</li>
              <li>Microsoft Copilot</li>
              <li>Apache Kafka</li>
              <li>Apache Maven</li>
              <li>PostgreSQL Datenbank</li>
              <li>Git (GitHub)</li>
              <li>Jira</li>
              <li>Kubernetes</li>
              <li>JUnit, Mockito</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Hypoport 2024–2026 -->
    <h2 class="paragraph-headline-2">Hypoport (Vergleich.de)</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>08/2024 – 09/2026</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Finanzen</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>Lübeck (Remote)</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Full-Stack-Entwickler (Java/Kotlin/Angular)</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Weiterentwicklung der Website vergleich.de</li>
              <li>Entwicklung neuer sowie Weiterentwicklung bestehender Backend-Services in Form von Microservices</li>
              <li>Entwicklung von Monitoring-Tools</li>
              <li>Deployment über TeamCity sowie GitHub Actions</li>
              <li>Entwicklung von REST-Schnittstellen</li>
              <li>Datenbankmigration Oracle zu PostgreSQL</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Java und Kotlin (inkl. Spring, Spring Boot, JPA, Hibernate)</li>
              <li>Angular (TypeScript) und JavaScript</li>
              <li>Amazon Web Service (AWS)</li>
              <li>BPMN und Camunda</li>
              <li>IntelliJ IDEA und WebStorm</li>
              <li>Apache Maven</li>
              <li>Oracle DB (und SQL Developer), MongoDB, PostgreSQL DB</li>
              <li>Git (GitLab, GitHub, Bitbucket)</li>
              <li>TeamCity</li>
              <li>Jira</li>
              <li>Docker</li>
              <li>JUnit, Mockito, Jasmine</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- TrumpPostAlert.com -->
    <h2 class="paragraph-headline-2">
      TrumpPostAlert.com
      <a
        class="external-link-icon"
        href="https://trumppostalert.com"
        target="_blank"
        rel="noreferrer"
        aria-label="TrumpPostAlert.com in neuem Tab öffnen">
        <mat-icon fontIcon="open_in_new"></mat-icon>
      </a>
    </h2>

    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>11/2025 – 11/2025</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Finanzen</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>München</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Gründer und Full-Stack-Entwickler (Kotlin/Angular, Google Cloud Platform)</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Machbarkeitsstudie für schnelle Umsetzung von Anforderungen mit KI-basierter Entwicklung („Vibe-Coding“)</li>
              <li>Entwicklung einer Single-Page-Web-App in Angular 20</li>
              <li>Entwicklung einer Backend-Server-Applikation in Kotlin</li>
              <li>
                Anbindung der Google Cloud Platform (Firebase): Authentication, Firestore NoSQL-Datenbank, Storage, Cloud Functions, Hosting
                und Cloud Run
              </li>
              <li>Anbindung einer NEON PostgreSQL-Datenbank</li>
              <li>
                Automatisierte, KI-basierte Auswertung von Donald Trumps Posts auf Truth Social und Analyse der Relevanz für Aktienmärkte
                und geopolitische Themen
              </li>
              <li>CI/CD über GitHub Actions unter Verwendung von Docker und Google Cloud Run</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Angular 20 (Angular Material, RxJS)</li>
              <li>Kotlin 2.2.20</li>
              <li>TypeScript 5.9.3</li>
              <li>Spring Boot 3.5.6</li>
              <li>Google Cloud Platform (Firebase, Cloud Run, Gemini, Vertex AI)</li>
              <li>ChatGPT Codex (Einsatz von „Vibe-Coding“)</li>
              <li>Git, GitHub, SourceTree</li>
              <li>IntelliJ WebStorm, IntelliJ IDEA</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Computer Futures / KRZN -->
    <h2 class="paragraph-headline-2">KRZN / Computer Futures</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>06/2023 – 12/2025</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Öffentlicher Dienst</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>Kamp-Lintfort (Remote)</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Full-Stack-Entwickler (Java/Angular)</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Weiterentwicklung und Anpassung der bestehenden Software</li>
              <li>Neuentwicklung eines Instanzmanagers (Java-Frontend und Angular-Backend) und eines Password-Stores</li>
              <li>Komplexitätsschätzungen</li>
              <li>Entwicklung von REST-Schnittstellen</li>
              <li>Authentifizierung mittels Keycloak</li>
              <li>Implementierung eines MFA-Login-Flows mit Shibboleth und PrivacyIDEA</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Angular 20 (Angular Material, RxJS)</li>
              <li>TypeScript</li>
              <li>Java 21</li>
              <li>Spring Boot 3.4.2</li>
              <li>Python</li>
              <li>PostgreSQL</li>
              <li>Keycloak, PrivacyIDEA</li>
              <li>Shibboleth IdP</li>
              <li>WebSocket</li>
              <li>Apache Kafka</li>
              <li>Docker, Kubernetes (mit Rancher)</li>
              <li>Git, GitLab, SourceTree</li>
              <li>IntelliJ IDEA Ultimate, IntelliJ WebStorm</li>
              <li>Jira, Confluence</li>
              <li>Clean Code Architecture</li>
              <li>JUnit, Mockito</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Callista / CSS -->
    <h2 class="paragraph-headline-2">CSS / Callista</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>03/2023</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Versicherung</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>Luzern</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Full-Stack-Entwickler (Java/Angular) / DevOps</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Weiterentwicklung und Anpassung der bestehenden Software</li>
              <li>Deployments in Kubernetes über TeamCity</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Angular 15 (Angular Material, RxJS)</li>
              <li>Java 18</li>
              <li>TypeScript</li>
              <li>Git, Bitbucket, SourceTree</li>
              <li>IntelliJ IDEA Ultimate</li>
              <li>Kubernetes</li>
              <li>Cypress Testing Framework</li>
              <li>Clean Code Architecture</li>
              <li>DDD</li>
              <li>Apache Kafka</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Stockforecast.de -->
    <h2 class="paragraph-headline-2">Stockforecast.de</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>01/2023 – 05/2023</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Finanzen</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>München</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Gründer und Full-Stack-Entwickler (Kotlin/Angular, Google Cloud Platform)</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Entwicklung einer Single-Page-Web-App in Angular 12</li>
              <li>Entwicklung einer Backend-Server-Applikation in Kotlin</li>
              <li>
                Anbindung der Google Cloud Platform (Firebase): Authentication, Firestore NoSQL-Database, Storage, Cloud Functions, Hosting
                und Cloud Run
              </li>
              <li>Anbindung der Financial Modelling Prep API als Datenquelle</li>
              <li>
                Automatisierte Auswertung historischer Aktiendaten zur Erkennung statistischer Regelmäßigkeiten („statistical trading“)
              </li>
              <li>CI/CD über GitHub Actions unter Verwendung von Docker und Google Cloud Run</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Angular 12 (Angular Material, RxJS)</li>
              <li>Kotlin 1.8.0</li>
              <li>TypeScript mit Bootstrap</li>
              <li>Spring Boot 3.0.3</li>
              <li>Google Cloud Platform (Firebase, Cloud Run)</li>
              <li>Git, GitHub, SourceTree</li>
              <li>IntelliJ WebStorm, IntelliJ IDEA</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Hypoport 2021–2023 -->
    <h2 class="paragraph-headline-2">Hypoport (Vergleich.de / Dr. Klein)</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>10/2021 – 01/2023</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Finanzen</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>Lübeck (Remote)</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Full-Stack-Entwickler (Java/Kotlin/Angular)</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Weiterentwicklung der Websites vergleich.de und drklein.de</li>
              <li>Entwicklung neuer sowie Weiterentwicklung bestehender Backend-Services in Form von Microservices</li>
              <li>Entwicklung von Monitoring-Tools</li>
              <li>Deployment über TeamCity sowie GitHub Actions</li>
              <li>Entwicklung von REST-Schnittstellen</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Java und Kotlin (inkl. Spring, Spring Boot, JPA, Hibernate)</li>
              <li>Angular (TypeScript) und JavaScript</li>
              <li>Amazon Web Services (AWS)</li>
              <li>IntelliJ IDEA und WebStorm</li>
              <li>Apache Maven</li>
              <li>Oracle DB (und SQL Developer), MongoDB</li>
              <li>Git (GitLab, GitHub, Bitbucket)</li>
              <li>TeamCity</li>
              <li>Jira</li>
              <li>Docker</li>
              <li>JUnit, Mockito, Jasmine</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Blitzshare.de -->
    <h2 class="paragraph-headline-2">
      Blitzshare.de
      <a
        class="external-link-icon"
        href="https://blitzshare.de"
        target="_blank"
        rel="noreferrer"
        aria-label="Blitzshare.de in neuem Tab öffnen">
        <mat-icon fontIcon="open_in_new"></mat-icon>
      </a>
    </h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>01/2021 – 12/2021</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Handel</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>München</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Gründer und Full-Stack-Entwickler (Kotlin/Angular, Google Cloud Platform)</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Entwicklung einer Single-Page-Web-App in Angular 12</li>
              <li>Entwicklung einer Backend-Server-Applikation in Kotlin</li>
              <li>
                Anbindung der Google Cloud Platform (Firebase): Authentication, Firestore NoSQL-Database, Storage, Cloud Functions und
                Hosting
              </li>
              <li>Anbindung diverser APIs, z. B. Google Geocoding API, Google Translation API, Algolia Search, Twilio SendGrid</li>
              <li>CI/CD über GitHub Actions</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Angular 12 (Angular Material, RxJS)</li>
              <li>Kotlin 1.4.21</li>
              <li>TypeScript mit Bootstrap</li>
              <li>Spring Boot 2.4.2</li>
              <li>Google Cloud Platform (Firebase)</li>
              <li>Git, GitHub, SourceTree</li>
              <li>IntelliJ WebStorm, IntelliJ IDEA</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- OSB / it@m -->
    <h2 class="paragraph-headline-2">it&#64;m / OSB</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>02/2019 – 12/2020</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Öffentlicher Dienst</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>München</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Backend-Entwickler (Java)</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Mitentwicklung des Basisframeworks für Online-Dienste der Landeshauptstadt München</li>
              <li>Weiter- und Neuentwicklung von Online-Diensten auf Grundlage von JavaServer Faces (JSF)</li>
              <li>Anbindung an bestehende Basiskomponenten wie ePayment oder Backend-Integration (per Webservice)</li>
              <li>Erstellen bzw. Anpassen technischer Dokumentation der entwickelten Programmteile (z. B. UML-Diagramme)</li>
              <li>Prüfung und Spezifikation zusätzlicher Produkte oder Frameworks zur Webentwicklung</li>
              <li>Entwicklung von Microservices</li>
              <li>JUnit-Testing, Test-driven Development (TDD)</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Java (inkl. Spring, JPA, Hibernate), JavaScript</li>
              <li>Eclipse IDE for Java EE Developers 2019-06</li>
              <li>Apache Maven, Apache Camel, ActiveMQ</li>
              <li>Oracle SQL Developer</li>
              <li>Git und Subversion</li>
              <li>Jenkins und SonarQube</li>
              <li>Mantis und TestLink</li>
              <li>LiMux (basierend auf Ubuntu Linux 18.04 LTS)</li>
              <li>JUnit</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Native Android -->
    <h2 class="paragraph-headline-2">Native Android-App-Entwicklung (Solo-Projekt)</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>02/2016 – 12/2020 (in Teilzeit)</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Spiele, Fitness</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>München</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Android-App-Entwickler</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Entwicklung einer Kartenspiel-App</li>
              <li>Entwicklung einer Fitness-Tracking-App mit Spring Boot Server-Komponente</li>
              <li>Installation und Administration eines Ubuntu-Servers und der nötigen Software für die Server-Komponente</li>
              <li>Entwicklung einer Gesundheits-App</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Java, Kotlin, Android Framework</li>
              <li>Gradle (App), Maven (Server-Anwendung)</li>
              <li>Android Studio (App), Eclipse EE (Server-Anwendung)</li>
              <li>Ubuntu 16.04.5 LTS</li>
              <li>Apache, Tomcat, MySQL, phpMyAdmin</li>
              <li>Subversion</li>
              <li>PuTTY und WinSCP</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Cataneo -->
    <h2 class="paragraph-headline-2">Cataneo GmbH</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>12/2015 – 02/2019</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>IT/Medien</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>München</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Backend-Entwickler (Java) und Team Leader Entwicklung</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Entwicklung neuer Programmmodule sowie Verbesserung und Erweiterung bestehender (primär Backend, auch Frontend)</li>
              <li>Leitung eines Entwicklungsteams aus 5 Personen</li>
              <li>Code Reviews und Fehleranalysen</li>
              <li>Datenimporte und -exporte (XML/XSD, Apache POI etc.)</li>
              <li>Entwicklung von RESTful Webservices</li>
              <li>Migration von ANT zu Maven</li>
              <li>Code-Dokumentation (UML, Markdown, AsciiDoc)</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Java 9 (inkl. Spring, Spring Boot, Spring Batch, Spring Security, Querydsl)</li>
              <li>JavaScript (inkl. jQuery) und Oracle SQL</li>
              <li>Maven</li>
              <li>Eclipse IDE for Java EE Developers 4.8 (Photon), VS Code</li>
              <li>Apache Kafka</li>
              <li>Oracle SQL Developer</li>
              <li>Git und Subversion</li>
              <li>PuTTY und WinSCP</li>
              <li>Jenkins</li>
              <li>SonarQube</li>
              <li>Jira und OTRS</li>
              <li>Windows 10 Pro, Microsoft Office 2019</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- MEAG / Conplan -->
    <h2 class="paragraph-headline-2">MEAG / Conplan GmbH</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>07/2014 – 11/2015</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>IT</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>München</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>System Test Manager</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Automatisierte Installation von Testrechnern mit Windows 7 64-bit zur Rollout-Vorbereitung</li>
              <li>Verwaltung der Rechner und Erstellung von Verlegungsaufträgen</li>
              <li>Unterstützung der Tester</li>
              <li>Unterstützung bei der Fehlersuche und Klärung von Defects</li>
              <li>Erstellen von Testplänen und Eintragen von Testabläufen in HP Quality Center</li>
              <li>Unterstützung in diversen Tätigkeiten der Projektleitung</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Windows Vista 32-bit und 7 64-bit</li>
              <li>Microsoft Office 2007 und 2013</li>
              <li>HP Quality Center</li>
              <li>SCCM und DDWI</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Institute for Cognitive Systems -->
    <h2 class="paragraph-headline-2">Institute for Cognitive Systems (TU München)</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>04/2014 – 01/2015</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Robotik</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>München</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Master's Thesis („Nutzung einer Vielzahl an Kameras am Äußeren eines Roboters als unidirektionaler Näherungssensor“)</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>
                Entwickeln eines Kamerasystems, das an die Gliedmaßen eines Roboters angebracht werden kann und als unidirektionaler
                Näherungssensor fungiert
              </li>
              <li>Entwickeln der Software zur Auswertung der Kamerabilder und Ermittlung der Entfernung von Gegenständen</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>C++ mit OpenCV</li>
              <li>QT</li>
              <li>Windows 7</li>
              <li>Ubuntu</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Far Galaxy Networks -->
    <h2 class="paragraph-headline-2">Far Galaxy Networks</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>06/2014 – 07/2014</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>IT</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>München</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>First and Second Level Support</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Userbetreuung</li>
              <li>1st und 2nd Level Serveradministration</li>
              <li>Verwaltung und Betreuung von Benutzerkonten und Mailboxen</li>
              <li>Betreuung der Kunden direkt vor Ort</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Windows 7, 8</li>
              <li>Windows Server 2008, 2012</li>
              <li>Active Directory</li>
              <li>LogMeIn</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- MunichRE / Conplan -->
    <h2 class="paragraph-headline-2">MunichRE / Conplan GmbH</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>08/2012 – 12/2012</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Versicherung</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>München</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Vorlagendesign und QS für Microsoft Office</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Design und Anpassung von Vorlagen für Microsoft Word 2007 und PowerPoint 2007</li>
              <li>HP-Quality Center Tests für Microsoft Word 2007, Outlook 2007, PowerPoint 2007, Excel 2007, Access 2007, Visio 2007</li>
              <li>Dateibestand protokollieren</li>
              <li>Verfassen von Testplänen für firmeninterne Tools und Testen</li>
              <li>Verfassen von Dokumentationen und Anleitungen für firmeninterne Tools</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Windows 7</li>
              <li>Microsoft Office 2007</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Verein der Studenten im Olympiazentrum -->
    <h2 class="paragraph-headline-2">Verein der Studenten im Olympiazentrum e.V.</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>04/2011 – 02/2012</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Mediendesign</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>München</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Magazindesign und Redaktion</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Erstellen einer Designvorlage (Microsoft Office) für das vereinsinterne Magazin Oly-Info</li>
              <li>Schreiben von Artikeln</li>
              <li>Übersetzung des gesamten Magazins ins Englische</li>
              <li>Kontakt zu den Ausschüssen des Vereins und Support</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Windows 7</li>
              <li>Microsoft Office 2007</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Siteco Bachelor's Thesis -->
    <h2 class="paragraph-headline-2">Siteco Beleuchtungstechnik (ehem. Siemens)</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>12/2011 – 02/2012</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Elektrotechnik</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>Traunreut</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Bachelor's Thesis („Programmierung eines Microcontrollers zur Entwicklung einer zirkadianen Leuchtensteuerung“)</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Lichttechnische Messungen durchführen</li>
              <li>Messdaten mathematisch auswerten</li>
              <li>Elektronische Bauteile aussuchen, bestellen und verbauen</li>
              <li>Umfangreiche Programmierung eines Atmel Microcontrollers</li>
              <li>Verwendung eines DCF77 Empfängers zur Bestimmung der aktuellen Uhrzeit</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Windows 7</li>
              <li>AVR Studio 4</li>
              <li>Atmel AT90PWM316 Microcontroller</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Siteco Praktikum -->
    <h2 class="paragraph-headline-2">Siteco Beleuchtungstechnik (ehem. Siemens)</h2>
    <table class="table table-striped table-sm table-responsive table-bordered">
      <tbody>
        <tr>
          <th>Zeitraum</th>
          <td>09/2011 – 11/2011</td>
        </tr>
        <tr>
          <th>Branche</th>
          <td>Elektrotechnik</td>
        </tr>
        <tr>
          <th>Standort</th>
          <td>Traunreut</td>
        </tr>
        <tr>
          <th>Positionsbezeichnung</th>
          <td>Ingenieurspraktikant</td>
        </tr>

        <tr>
          <th>Aufgaben</th>
          <td>
            <ul>
              <li>Firmwareupdates auf Leuchtencontrollern durchführen</li>
              <li>Programmierung diverser Entwicklungstools in Delphi</li>
              <li>Löten mehrerer Modellschaltungen für Trainingszwecke</li>
              <li>
                Messungen von Schwingquarzen am Oszilloskop bei verschiedenen Temperaturen, anschließendes Ersetzen durch andere Quarze und
                erneute Messung. Dokumentation der Ergebnisse.
              </li>
              <li>Unterstützung bei mathematischen Berechnungen</li>
            </ul>
          </td>
        </tr>

        <tr>
          <th>Technisches Umfeld</th>
          <td>
            <ul>
              <li>Windows 7</li>
              <li>Turbo Delphi</li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
  </article>
</section>
